// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asset-management {
  animation: fadeIn 0.3s ease;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.stat-card.blue .stat-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-card.green .stat-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.stat-card.info .stat-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.stat-card.orange .stat-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.stat-info h3 {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.stat-info p {
  color: var(--text-secondary);
  font-size: 13px;
}

.filters-section {
  background: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex-wrap: wrap;
}

.search-box {
  flex: 1 1;
  min-width: 250px;
  position: relative;
}

.search-box i {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
}

.search-box input {
  width: 100%;
  padding: 12px 15px 12px 45px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
}

.filter-group {
  display: flex;
  gap: 10px;
}

.filter-group select {
  padding: 12px 15px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  cursor: pointer;
}

.asset-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.asset-info i {
  color: var(--primary-color);
  font-size: 18px;
}

.type-badge {
  display: inline-block;
  padding: 4px 12px;
  background: #e0e7ff;
  color: #4f46e5;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.serial-number {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: var(--text-secondary);
}

.assigned-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary);
}

.assigned-info i {
  color: var(--primary-color);
}

.text-muted {
  color: var(--text-secondary);
  font-style: italic;
}

.condition-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.condition-new {
  background: #dbeafe;
  color: #1e40af;
}

.condition-excellent {
  background: #d1fae5;
  color: #065f46;
}

.condition-good {
  background: #dcfce7;
  color: #166534;
}

.condition-fair {
  background: #fef3c7;
  color: #92400e;
}

.condition-poor {
  background: #fee2e2;
  color: #991b1b;
}

.price {
  font-weight: 600;
  color: var(--text-primary);
}

/* Asset Details Modal */
.asset-details {
  max-height: 70vh;
  overflow-y: auto;
}

.detail-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px;
  margin-bottom: 25px;
}

.detail-icon {
  font-size: 48px;
}

.detail-header h3 {
  font-size: 24px;
  margin-bottom: 8px;
  color: white;
}

.detail-header .badge {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.detail-section {
  background: #f9fafb;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
}

.detail-section h4 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  font-size: 16px;
  color: var(--text-primary);
}

.detail-section h4 i {
  color: var(--primary-color);
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.detail-item label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-item span {
  font-size: 14px;
  color: var(--text-primary);
}

.price-highlight {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #10b981 !important;
}

/* Form Styles */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.form-input {
  padding: 12px 15px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

/* Responsive */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .filters-section {
    flex-direction: column;
    align-items: stretch;
  }

  .search-box {
    min-width: 100%;
  }

  .filter-group {
    flex-direction: column;
  }

  .filter-group select {
    width: 100%;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AssetManagement.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".asset-management {\n  animation: fadeIn 0.3s ease;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.stat-card.blue .stat-icon {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.stat-card.green .stat-icon {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.stat-card.info .stat-icon {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n}\n\n.stat-card.orange .stat-icon {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n}\n\n.stat-icon {\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  color: white;\n}\n\n.stat-info h3 {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.stat-info p {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.filters-section {\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  flex-wrap: wrap;\n}\n\n.search-box {\n  flex: 1;\n  min-width: 250px;\n  position: relative;\n}\n\n.search-box i {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n}\n\n.search-box input {\n  width: 100%;\n  padding: 12px 15px 12px 45px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.filter-group {\n  display: flex;\n  gap: 10px;\n}\n\n.filter-group select {\n  padding: 12px 15px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n}\n\n.asset-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.asset-info i {\n  color: var(--primary-color);\n  font-size: 18px;\n}\n\n.type-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  background: #e0e7ff;\n  color: #4f46e5;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.serial-number {\n  font-family: 'Courier New', monospace;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.assigned-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-primary);\n}\n\n.assigned-info i {\n  color: var(--primary-color);\n}\n\n.text-muted {\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.condition-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.condition-new {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.condition-excellent {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.condition-good {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.condition-fair {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.condition-poor {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.price {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Asset Details Modal */\n.asset-details {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.detail-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 12px;\n  margin-bottom: 25px;\n}\n\n.detail-icon {\n  font-size: 48px;\n}\n\n.detail-header h3 {\n  font-size: 24px;\n  margin-bottom: 8px;\n  color: white;\n}\n\n.detail-header .badge {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.detail-section {\n  background: #f9fafb;\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n}\n\n.detail-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 15px;\n  font-size: 16px;\n  color: var(--text-primary);\n}\n\n.detail-section h4 i {\n  color: var(--primary-color);\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.detail-item label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-item span {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.price-highlight {\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  color: #10b981 !important;\n}\n\n/* Form Styles */\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.form-input {\n  padding: 12px 15px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 20px;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .filters-section {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .search-box {\n    min-width: 100%;\n  }\n\n  .filter-group {\n    flex-direction: column;\n  }\n\n  .filter-group select {\n    width: 100%;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
